export const common = Object.freeze({
  selectPerPageItems: 5,
});
